export default {
  default: {
    shareButton: 'Share',
    downloadButton: 'Download',
  },
}
